export default __webpack_public_path__ + "static/media/2025-no-limits-stacked.0a2ba645.png";